import React from 'react';
import { cn } from '../../../utils/cn';
import './Badge.scss';

/**
 * Badge component for labels and status indicators
 * Supports "New" and "Popular" variants
 */

const Badge = React.forwardRef(({ className, variant = 'default', children, ...props }, ref) => {
  const variantClass = `badge-ui--${variant}`;

  return (
    <span ref={ref} className={cn('badge-ui', variantClass, className)} {...props}>
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;
